import React, { useEffect, useState } from "react";
import axios from "axios";
const { getNewYorkDateTime } = require("../utils/dateUtils");
function AllForms({ currentUser }) {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [formData, setFormData] = useState({});
  const [showAgentDialog, setShowAgentDialog] = useState(false);

  

// put these with your other useState hooks



 // const states = ["AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"];
   const states = ["AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY","GU",
"MP",
"PR",
"VI",
"DC"];
  
  // Filters
 // const [tableFilter, setTableFilter] = useState("all");
const [phoneFilter, setPhoneFilter] = useState("");
const [, setAppliedPhoneFilter] = useState("");

  const houseTypes = ["Own", "Rented"];
  //const accountTypes = ["Checking", "Savings"];
  const [leadSources, setLeadSources] = useState([]); // ✅ new state
   const [campaigns, setCampaigns] = useState([]);
  // Dispositions dropdown
  const [dispositions, setDispositions] = useState([]);

  useEffect(() => {
    const fetchDispositions = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/dispositions");
        const active = res.data.filter((d) => d.isActive === "Active");
        setDispositions(active);
      } catch (err) {
        console.error("⚠️ Error fetching dispositions:", err);
      }
    };
    fetchDispositions();
  }, []);


 // const [loading, setLoading] = useState(true); // ✅ loading state
 // ✅ Fetch Lead Sources from backend on mount
  useEffect(() => {
    const fetchLeadSources = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/leadsources");
        setLeadSources(res.data);
      } catch (err) {
        console.error("⚠️ Error fetching lead sources:", err);
      }
    };
    fetchLeadSources();
  }, []);
  
useEffect(() => {
  const fetchCampaigns = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns");

      console.log("Raw campaigns response:", res.data);

      // check if it's array or inside data property
      const campaignsData = Array.isArray(res.data) ? res.data : res.data.data;

      console.log("Parsed campaignsData:", campaignsData);

      // filter by isActive (boolean)
      const activeCampaigns = campaignsData.filter((c) => c.isActive);

      console.log("Active campaigns:", activeCampaigns);

      setCampaigns(activeCampaigns);
    } catch (err) {
      console.error("⚠️ Error fetching campaigns:", err);
    }
  };

  fetchCampaigns();
}, []);

const [loading, setLoading] = useState(false);
//const [ loading1, setLoading1] = useState(false);



// const [totalForms, setTotalForms] = useState(0);  

//comment on 15- nov -----------------------------------------------------------------------------------------------------------------------------------


// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       setLoading1(true);
//       const agentsRes = await axios.get("https://crm-server-htk6.vercel.app/api/agents");
//       const allAgents = agentsRes.data || [];

//       const centerAgents = allAgents
//         .filter(
//           (agent) =>
//             agent.centerName?.trim().toLowerCase() ===
//             (currentUser?.center || "").trim().toLowerCase()
//         )
//         .sort((a, b) => {
//           const dateA = new Date(a.verifiedDate || a.submittedDate);
//           const dateB = new Date(b.verifiedDate || b.submittedDate);
//           return dateB - dateA;
//         });

//       setAgents(centerAgents);
//       setTotalForms(centerAgents.length);

//       setAppliedFromDate(todayStr);
//       setAppliedToDate(todayStr);
//       setAppliedPhoneFilter("");
//     } catch (err) {
//       console.error("❌ Error fetching agents:", err);
//     } finally {
//       setLoading1(false);
//     }
//   };

//   if (currentUser?.center) fetchData();
// }, [currentUser, todayStr]);   // ✅ include todayStr


// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       setLoading1(true);
//       const agentsRes = await axios.get("https://crm-server-htk6.vercel.app/api/agents");
//       const allAgents = agentsRes.data || [];

//       const centerAgents = allAgents
//         // .filter(
//         //   (agent) =>
//         //     agent.centerName?.trim().toLowerCase() ===
//         //     (currentUser?.center || "").trim().toLowerCase()
//         // )
//         .sort((a, b) => {
//           const dateA = new Date(a.verifiedDate || a.submittedDate);
//           const dateB = new Date(b.verifiedDate || b.submittedDate);
//           return dateB - dateA;
//         });

//       setAgents(centerAgents);
//       setTotalForms(centerAgents.length);

//       // 👇 Apply today's filter automatically
//       setAppliedFromDate(todayStr);
//       setAppliedToDate(todayStr);
//       setAppliedPhoneFilter("");

//     } catch (err) {
//       console.error("❌ Error fetching agents:", err);
//     } finally {
//       setLoading1(false);
//     }
//   };

//   if (currentUser?.center) fetchData();
// }, [currentUser]);



useEffect(() => {
  if (formData.product) {
    // Split by comma and trim spaces
    const initial = formData.product.split(",").map(p => p.trim());
    setSelectedProducts(initial);
  }
}, [formData.product]); // runs whenever formData.product changes

  // Open agent form
  const handleAgentSelect = (agent) => {
    setSelectedAgent(agent);
    setFormData({ ...agent });
    setShowAgentDialog(true);
  };

  // Handle input changes
const handleChange = (e) => {
  const { name, value, type } = e.target;

  // Skip uppercasing for date, numbers, and dropdowns
  if (type === "date" || type === "number" || e.target.tagName === "SELECT") {
    setFormData({ ...formData, [name]: value });
  } else {
    setFormData({ ...formData, [name]: value.toUpperCase() });
  }

  // ✅ If user deselects card type, clear card number
  if (name === "cardType" && value === "") {
    setFormData((prev) => ({ ...prev, cardNumber: "" }));
  }

  // ✅ If State or Card Type changes, reset Open Product and product list
  if (name === "state" || name === "cardType") {
   // setFormData((prev) => ({ ...prev, product: "" }));
   // setFilteredProducts([]); // Clear validated product list
   // setSelectedProducts([]); // Clear checked products
  }
};

  // DOB Validation
function validateDOB(dobValue) {
  if (!dobValue) {
    return { valid: false, message: "⚠️ Date of Birth is required!" };
  }

  // expecting YYYY-MM-DD
  const [year, month, day] = dobValue.split("-");
  const dob = new Date(year, month - 1, day);

  if (isNaN(dob.getTime())) {
    return { valid: false, message: "⚠️ Invalid Date of Birth format!" };
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  if (age < 18) {
    return { valid: false, message: "⚠️ You must be at least 18 years old!" };
  }

  return { valid: true };
}

// Mask everything except last 4 characters
const maskValue = (value) => {
  if (!value) return "";
  const str = value.toString();
  return str.length > 4 ? "*".repeat(str.length - 4) + str.slice(-4) : str;
};


// Full Validation
function validateForm(formData) {
  const mandatoryFields = [
    "firstName", "lastName", "gender", "phone",
    "address", "city", "state", "zip", "campaign" , "leadSource"
    
  ];


  // 👉 New rule for disposition = "Sale"
  if (formData.disposition === "Sale") {
    if (!formData.comments?.trim()) {
      return { valid: false, message: "⚠️ Comments are required for a Sale disposition." };
    }
    if (!formData.trackId?.trim()) {
      return { valid: false, message: "⚠️ Track ID is required for a Sale disposition." };
    }
    if (!formData.verifCode?.trim()) {
      return { valid: false, message: "⚠️ Verifier Code is required for a Sale disposition." };
    }
  }

  



  // Mandatory fields
  for (let field of mandatoryFields) {
    if (!formData[field] || formData[field].toString().trim() === "") {
      return { valid: false, message: `⚠️ ${field} is required!` };
    }
  }

  // Phone
  const phoneRegex = /^[2-9]\d{9}$/;
  if (!phoneRegex.test(formData.phone)) {
    return { valid: false, message: "⚠️ Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Zip
  const zipRegex = /^\d{5}$/;
  if (!zipRegex.test(formData.zip)) {
    return { valid: false, message: "⚠️ Zip Code must be exactly 5 digits!" };
  }

  // DOB
  // ✅ Only validate if DOB is not empty
if (formData.dob) {
  const dobValidation = validateDOB(formData.dob);
  if (!dobValidation.valid) return dobValidation;
}


  // Alternate Phone
  if (formData.alternatePhone && !/^[2-9]\d{9}$/.test(formData.alternatePhone)) {
    return { valid: false, message: "⚠️ Alternate Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Routing Number
  if (formData.routingNumber && !/^\d{9}$/.test(formData.routingNumber)) {
    return { valid: false, message: "⚠️ Routing Number must be 9 digits!" };
  }

  // ✅ Card Number Validation
if (formData.cardType) {
  const cardNum = formData.cardNumber;
  if (!cardNum) {
    return { valid: false, message: "⚠️ Please enter Card Number!" };
  }

  // ✅ Remove "-" for validation
  const cleanCardNum = cardNum.replace(/-/g, "");

  const rules = {
    Visa: {
      regex: /^4\d{15}$/, 
      hint: "Visa cards must start with 4 and be 16 digits long."
    },
    "Master Card": {
      regex: /^5\d{15}$/, 
      hint: "MasterCard must start with 5 and be 16 digits long."
    },
    Discover: {
      regex: /^6\d{15}$/, 
      hint: "Discover cards must start with 6 and be 16 digits long."
    },
    "American Express": {
      regex: /^3\d{14}$/, 
      hint: "American Express must start with 3 and be 15 digits long."
    }
  };

  const rule = rules[formData.cardType];

  // ✅ check card type support
  if (!rule) {
    return { valid: false, message: `⚠️ Unsupported Card Type: ${formData.cardType}` };
  }

  // ✅ apply validation on sanitized number
  if (!rule.regex.test(cleanCardNum)) {
    return { valid: false, message: `⚠️ ${rule.hint}` };
  }
}



  // CVV
  if (formData.cvv && !/^\d{3}$/.test(formData.cvv)) {
    return { valid: false, message: "⚠️ CVV must be 3 digits!" };
  }

  // Expiry
  if (formData.expiry && !/^(0[1-9]|1[0-2])\/\d{2}$/.test(formData.expiry)) {
    return { valid: false, message: "⚠️ Expiry must be in MM/YY format!" };
  }

  return { valid: true };
}


const handleNumericInput = (e) => {
  const re = /^[0-9\b]+$/; // only digits
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

  // ✅ Update agent and post log
const handleAgentUpdate = async () => {
  // Run Validation
  const validation = validateForm(formData);
  if (!validation.valid) {
    alert(validation.message);
    return; // stop update if validation fails
  }

  try {
    const payload = { ...formData, verifiedDate: getNewYorkDateTime(), };
    delete payload._id; // Remove _id before sending PUT request

    // 1️⃣ Update Agent
    const res = await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${selectedAgent._id}`,
      payload
    );

    if (res.data.success) {
      alert("✅ Agent form updated successfully");

      // Update local state
      setShowAgentDialog(false);
      setAgents((prev) =>
        prev.map((a) =>
          a._id === selectedAgent._id ? { ...selectedAgent, ...payload } : a
        )
      );

      // 2️⃣ Save Logs (only after successful update)
      try {
        const logData = {
          ...payload,
      //  logDate: new Date().toLocaleString("en-US", { timeZone: "America/New_York" }),
      
logDate: getNewYorkDateTime(),
          user: currentUser?.firstName || "",
          userCenter: currentUser?.center || "",
          userEmpCode: currentUser?.empCode || "",
          userRole: currentUser?.role || "",
          action: "Update", // ✅ identify update action
        };

        await fetch("https://crm-server-htk6.vercel.app/api/logs", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(logData),
        });

        console.log("📜 Log saved successfully");
      } catch (logErr) {
        console.error("⚠️ Error saving log:", logErr);
      }
    } else {
      alert("❌ Failed to update agent");
    }
  } catch (err) {
    console.error("⚠️ Error updating agent:", err);
    alert("❌ Failed to update agent");
  }
};


useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/products");

      // Filter only active products
      const activeProducts = res.data.filter(p => p.isActive === "Active");

      setProducts(activeProducts);
    } catch (err) {
      console.error("⚠️ Error fetching products:", err);
    }
  };
  fetchProducts();
}, []);

  
  // ------^&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&     VALIDATE PRODUCT AFTER RULES APPLIED   %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  
      const [products, setProducts] = useState([]);
      const [selectedProducts, setSelectedProducts] = useState([]);
      const [filteredProducts, setFilteredProducts] = useState([]); // Products after validation
     
    useEffect(() => {
      const validateProducts = async () => {
        try {
          setLoading(true);
  
          let validatedProducts = [...products];
          let blockedProducts = new Set();
          const centerName = currentUser?.center || "";
  
          // --- Product Mapping Validation ---
          // if (centerName && formData.leadSource && formData.campaign) {
          //   try {
          //     const mapRes = await axios.get(
          //       "https://crm-server-htk6.vercel.app/api/productMappings",
          //       {
          //         params: {
          //           center: centerName,
          //           leadSource: formData.leadSource,
          //           campaign: formData.campaign,
          //         },
          //       }
          //     );
          //     const mapping = mapRes.data;
          //     if (mapping && Array.isArray(mapping.products)) {
          //       validatedProducts = validatedProducts.filter(
          //         (p) => !mapping.products.includes(p.productName)
          //       );
          //     }
          //   } catch (mapErr) {
          //     console.error("Mapping error:", mapErr);
          //   }
          // }


          
                  if (centerName && formData.leadSource && formData.campaign) {
            try {
              const mapRes = await axios.get(
                "https://crm-server-htk6.vercel.app/api/productMappings",
                {
                  params: {
                    center: centerName,
                    leadSource: formData.leadSource,
                    campaign: formData.campaign,
                  },
                }
              );
          
              const mapping = mapRes.data;
              if (mapping && Array.isArray(mapping.products)) {
                validatedProducts = validatedProducts.filter(
                  (p) => mapping.products.includes(p.productName)
                );
              }
            } catch (mapErr) {
              console.error("Mapping error:", mapErr);
            }
          }
          


  
          // --- Per-product rules ---
          for (let product of [...validatedProducts]) {
            try {
              const res = await axios.get(
                `https://crm-server-htk6.vercel.app/api/productRules/${product._id}`
              );
              const rules = res.data;
  
              if (product.isActive !== "Active") {
                validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
                continue;
              }
  
              if (rules.states?.includes(formData.state)) {
                validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
                continue;
              }
  
              if (rules.cardTypes?.includes(formData.cardType)) {
                validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
                continue;
              }
  
              // if (rules.productGroup?.length) {
              //   rules.productGroup.forEach((bp) => blockedProducts.add(bp));
              // }
  
           if (formData.cardNumber && formData.cardNumber.length >= 6) {
  // 1️⃣ Remove hyphens or spaces
  const cleanCard = formData.cardNumber.replace(/[^0-9]/g, "");

  // 2️⃣ Extract first 6 digits
  const cardPrefix = cleanCard.substring(0, 6);

  try {
    const binRes = await axios.get(
      `https://crm-server-htk6.vercel.app/api/bins/${product.productName}`
    );

    const bins = binRes.data;

    // 3️⃣ Correct BIN comparison
    const isBlockedByBin = bins.some((bin) => {
      const start = Number(bin.StartRange);
      const end = Number(bin.EndRange);
      const prefix = Number(cardPrefix);
      return prefix >= start && prefix <= end;
    });

    if (isBlockedByBin) {
      validatedProducts = validatedProducts.filter(
        (p) => p._id !== product._id
      );

      // 👉 also store it in blockedProducts state
      setBlockedProducts((prev) => new Set([...prev, product.productName]));

      continue;
    }
  } catch (binErr) {
    console.error(`Bin error for ${product.productName}:`, binErr);
  }
}

            } catch (ruleErr) {
              console.error(`Rule error for ${product.productName}:`, ruleErr);
            }
          }
  
          // Remove blocked by productGroup
          validatedProducts = validatedProducts.filter(
            (p) => !blockedProducts.has(p.productName)
          );
  
          setFilteredProducts(validatedProducts);
        } catch (err) {
          console.error("Validation failed:", err);
        } finally {
          setLoading(false);
        }
      };
  
      // Run validation if at least one key input is set
      if (products.length) {
        validateProducts();
      }
    }, [
      products,
      formData.state,
      formData.cardType,
      formData.campaign,
      formData.leadSource,
      formData.cardNumber,
      currentUser
    ]);
  
  
  
    // const handleProductSelect = (productName) => {
    //   let updatedProducts = selectedProducts.includes(productName)
    //     ? selectedProducts.filter((p) => p !== productName)
    //     : [...selectedProducts, productName];
  
    //   setSelectedProducts(updatedProducts);
    //   setFormData((prev) => ({ ...prev, product: updatedProducts.join(", ") }));
    // };
  

const [blockedProducts, setBlockedProducts] = useState(new Set());

const handleProductSelect = async (productName) => {
  setLoading(true);
  let updatedSelected = [...selectedProducts];
  let updatedBlocked = new Set(blockedProducts);

  try {
    // Toggle select/deselect
    if (updatedSelected.includes(productName)) {
      // Deselect
      updatedSelected = updatedSelected.filter((p) => p !== productName);

      // Recalculate blocked products based on remaining selections
      let newBlocked = new Set();
      for (let pName of updatedSelected) {
        const prod = products.find((x) => x.productName === pName);
        if (prod) {
          const res = await axios.get(
            `https://crm-server-htk6.vercel.app/api/productRules/${prod._id}`
          );
          const rules = res.data;
          if (rules.productGroup?.length) {
            rules.productGroup.forEach((bp) => newBlocked.add(bp));
          }
        }
      }
      updatedBlocked = newBlocked;
    } else {
      // Select product
      updatedSelected.push(productName);

      // Fetch rule for selected product
      const selectedProd = products.find((x) => x.productName === productName);
      if (selectedProd) {
        const res = await axios.get(
          `https://crm-server-htk6.vercel.app/api/productRules/${selectedProd._id}`
        );
        const rules = res.data;

        // Add all group members to blocked set
        if (rules.productGroup?.length) {
          rules.productGroup.forEach((bp) => updatedBlocked.add(bp));
        }
      }
    }

    setSelectedProducts(updatedSelected);
    setBlockedProducts(updatedBlocked);
    setFormData((prev) => ({ ...prev, product: updatedSelected.join(", ") }));
  } catch (err) {
    console.error("Error in handleProductSelect:", err);
  } finally {
    setLoading(false);
  }
};



  // Apply name filter
  // const applyNameSearch = () => {
  //   setAppliedNameFilter(nameFilter.trim().toLowerCase());
  // };

// 🔹 Filter Function

// const filteredAgents = agents.filter((a) => {
//   if (appliedPhoneFilter) {
//     const phone = (a.phone || "").toLowerCase();
//     if (!phone.includes(appliedPhoneFilter)) return false;
//   }

//   if (appliedFromDate && appliedToDate && a.submittedDate) {
//     const formDate = new Date(a.submittedDate).setHours(0, 0, 0, 0);
//     const from = new Date(appliedFromDate).setHours(0, 0, 0, 0);
//     const to = new Date(appliedToDate).setHours(23, 59, 59, 999);
//     if (formDate < from || formDate > to) return false;
//   }

//   return true;
// });


// const filteredAgents = agents.filter((a) => {
//   if (appliedPhoneFilter) {
//     const phone = (a.phone || "").toLowerCase();
//     if (!phone.includes(appliedPhoneFilter)) return false;
//   }

//   if (appliedFromDate && appliedToDate && a.submittedDate) {
//     const formDate = new Date(a.submittedDate).setHours(0, 0, 0, 0);
//     const from = new Date(appliedFromDate).setHours(0, 0, 0, 0);
//     const to = new Date(appliedToDate).setHours(23, 59, 59, 999);

//     if (formDate < from || formDate > to) return false;
//   }

//   return true;
// });



// const filteredAgents = agents.filter((a) => {
//   // ------- PHONE FILTER -------
//   if (appliedPhoneFilter) {
//     const phone = (a.phone || "").toLowerCase();
//     if (!phone.includes(appliedPhoneFilter)) return false;
//   }

//   // ------- DATE FILTER -------
//   if (appliedFromDate && appliedToDate && a.submittedDate) {

//     // 1️⃣ Extract only "MM/DD/YYYY" from DB
//     const dbDate = a.submittedDate.split(",")[0].trim();  
//     // Example: "11/19/2025"

//     // 2️⃣ Convert input date (YYYY-MM-DD) → "MM/DD/YYYY"
//     const from = new Date(appliedFromDate).toLocaleDateString("en-US");
//     const to = new Date(appliedToDate).toLocaleDateString("en-US");

//     // 3️⃣ Compare PURE string dates (no timezone issues)
//     if (dbDate < from || dbDate > to) return false;
//   }

//   return true;
// });





// const applyFilters = () => {
//   if (!fromDate || !toDate)
//     return alert("⚠️ Please select a valid date range.");

//   if (new Date(fromDate) > new Date(toDate))
//     return alert("⚠️ 'From' date cannot be later than 'To' date.");

//   setLoading(true); // ⏳ start table loading

//   setTimeout(() => {
//     setAppliedPhoneFilter(phoneFilter.trim().toLowerCase());
//     setAppliedFromDate(fromDate);
//     setAppliedToDate(toDate);

//     setLoading(false); // ✅ stop loading after filters applied
//   }, 200);  // small delay so loader renders
// };




const todayStr = new Date().toISOString().slice(0, 10);

const [fromDate, setFromDate] = useState(todayStr);
const [toDate, setToDate] = useState(todayStr);
const [, setAppliedFromDate] = useState(todayStr);
const [, setAppliedToDate] = useState(todayStr);


const convertToMMDDYYYY = (dateStr) => {
  // dateStr from <input type="date"> → "YYYY-MM-DD"
  const [year, month, day] = dateStr.split("-");
  return `${month}/${day}/${year}`; // → "MM/DD/YYYY"
};

const applyFilters = async () => {
  if (!phoneFilter.trim() && (!fromDate || !toDate)) {
    return alert("⚠️ Please enter phone or select a date range.");
  }

  if (fromDate && toDate) {
    if (fromDate > toDate) {
      return alert("⚠️ 'From' date cannot be later than 'To' date.");
    }
  }

  setLoading(true);

  try {
    const res = await axios.get(
      "https://crm-server-htk6.vercel.app/api/agents/filter",
      {
        params: {
          phone: phoneFilter.trim() || undefined,
          fromDate: fromDate ? convertToMMDDYYYY(fromDate) : undefined,
          toDate: toDate ? convertToMMDDYYYY(toDate) : undefined,
        },
      }
    );

    const agentsArray = Array.isArray(res.data) ? res.data : Object.values(res.data);
    setAgents(agentsArray);

    setAppliedPhoneFilter(phoneFilter.trim());
    setAppliedFromDate(fromDate);
    setAppliedToDate(toDate);
  } catch (err) {
    console.error("❌ Filter error:", err);
    alert("⚠️ Error fetching filtered results");
  }

  setLoading(false);
};



  return (
    
    <div className="allforms-container">
 {/* {loading1 && (
  <div className="loading-overlay">
    <div className="spinner"></div>
    ⏳ Fetching All Forms ...
  </div>
)} */}


      <h2>Filters : </h2>

     
<div
  className="form-row"
  style={{
    marginBottom: "15px",
    display: "flex",
    gap: "10px",
    alignItems: "center"
  }}
>
  {/* Phone Filter */}
  <input
    type="text"
    placeholder="Search by Phone"
    value={phoneFilter}
    onChange={(e) => setPhoneFilter(e.target.value)}
    style={{ flex: "1" }}
  />

  {/* Date Range Filter */}
  <label>From:</label>
 <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
  <label>To:</label>
<input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
  <button className="btn save" onClick={applyFilters}>
    Go
  </button>
</div>


      {/* Agent Table */}
     
     <>
  <h3>Forms</h3>
  {/* <p>
    Total Forms (Center): <strong>{totalForms}</strong>
    
  </p> */}
  <div className="table-wrapper">
  <table className="allforms-agent-table">
    <thead>
      <tr>
        <th>CustomerID</th>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Disposition</th>
         <th>Product Sold</th>
           <th>submittedDate</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {loading ? (
        <tr>
          <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
            ⏳ Loading...
          </td>
        </tr>
      ) : agents.length === 0 ? (
        <tr>
          <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
            No matching agents
          </td>
        </tr>
      ) : (
        agents.map((agent) => (
          
          <tr key={agent._id}>
                <td>{agent.CustomerID}</td>
            <td>{agent.firstName} {agent.lastName}</td>
            <td>{agent.email}</td>
            <td>{agent.phone}</td>
            <td>{agent.disposition}</td>
            <td>{agent.product}</td>
            <td>{agent.submittedDate}</td>
            
            <td>
              <button onClick={() => handleAgentSelect(agent)}>View/Edit</button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
  </div>
</>

     

    {/* Agent Dialog */}
{showAgentDialog && selectedAgent && (
  <div className="verify-dialog-overlay">
    <div className="verify-dialog-box">
      <h2 className="verify-dialog-title">Agent & Verification Details</h2>

      <form className="verify-dialog-form">
        {/* --- Personal Info --- */}
        <div className="verify-form-row">
          <div className="verify-form-group">
            <label>First Name *</label>
            <input
              name="firstName"
              value={formData.firstName || ""}
              onChange={handleChange}
            />
          </div>
           <div className="verify-form-group">
            <label>Middle Name </label>
            <input
              name="middleName"
              value={formData.middleName || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>Last Name *</label>
            <input
              name="lastName"
              value={formData.lastName || ""}
              onChange={handleChange}
            />
          </div>
           <div className="verify-form-group">
            <label>Gender *</label>
            <select name="gender" value={formData.gender} onChange={handleChange}>
              <option value="">Select</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>
        </div>

        <div className="verify-form-row">
         
          <div className="verify-form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
            />
          </div>
           <div className="verify-form-group">
            <label>Phone *</label>
            <input
              name="phone"
              maxLength={10}
              value={formData.phone || ""}
              onChange={handleChange}
              onKeyPress={handleNumericInput}
            />
          </div>
          <div className="verify-form-group">
            <label>Alternate Phone</label>
            <input
              name="alternatePhone"
              maxLength={10}
              value={formData.alternatePhone || ""}
              onChange={handleChange}
              onKeyPress={handleNumericInput}
            />
          </div>
        </div>

        {/* --- Address --- */}
        <div className="verify-form-row">
          <div className="verify-form-group">
            <label>Address *</label>
            <input
              name="address"
              value={formData.address || ""}
              onChange={handleChange}
            />
          </div>
           <div className="verify-form-group">
            <label>Address 2</label>
            <input
              name="apt"
              value={formData.apt || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="verify-form-row">
          <div className="verify-form-group">
            <label>City *</label>
            <input name="city" value={formData.city || ""} onChange={handleChange} />
          </div>
          <div className="verify-form-group">
            <label>State *</label>
            <select name="state" value={formData.state} onChange={handleChange}>
              <option value="">Select</option>
              {states.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
            <div className="verify-form-group">
            <label>Zip Code *</label>
            <input
              name="zip"
              maxLength={5}
              value={formData.zip || ""}
              onChange={handleChange}
              onKeyPress={handleNumericInput}
            />
          </div>
        </div>

        <div className="verify-form-row">
        
          <div className="verify-form-group">
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>House Type</label>
            <select
              name="houseType"
              value={formData.houseType}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {houseTypes.map((h) => (
                <option key={h} value={h}>
                  {h}
                </option>
              ))}
            </select>
          </div>
            <div className="verify-form-group">
            <label>Routing Number</label>
            <input
              name="routingNumber"
              value={formData.routingNumber || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>Lead Source *</label>
            <select
              name="leadSource"
              value={formData.leadSource}
              onChange={handleChange}
            >
              <option value="">-- Select Lead Source --</option>
              {leadSources.map((src) => (
                <option key={src._id} value={src.name}>
                  {src.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Banking --- */}
        <div className="verify-form-row">
          
          <div className="verify-form-group">
            <label>Bank Name</label>
            <input
              name="bankName"
              value={formData.bankName || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>Account Number</label>
            <input
              name="accountNumber"
              value={formData.accountNumber || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>Account Type</label>
            <input
              name="accountType"
              value={maskValue(formData.accountType)}
              readOnly
            />
          </div>
        </div>

        {/* --- Card --- */}
        <div className="verify-form-row">
          <div className="verify-form-group">
            <label>Card Type</label>
            <input name="cardType" value={formData.cardType} readOnly />
          </div>
          <div className="verify-form-group">
            <label>Card Number</label>
            <input
              name="cardNumber"
              value={maskValue(formData.cardNumber)}
              readOnly
            />
          </div>
            <div className="verify-form-group">
            <label>Expiry</label>
            <input
              name="expiry"
              placeholder="MM/YY"
              value={formData.expiry || ""}
              onChange={handleChange}
            />
          </div>
           <div className="verify-form-group">
            <label>CVV</label>
            <input
              name="cvv"
              maxLength={3}
              value={maskValue(formData.cvv)}
              readOnly
            />
          </div>
        </div>

        <div className="verify-form-row">
        
         
        </div>

        {/* --- Products --- */}
        <div className="verify-form-group full-width">
          <label>Selected Products</label>
          <textarea name="product" value={formData.product || ""} readOnly />
        </div>

        {/* <div className="verify-form-group full-width">
          <label>Open Products</label>
         <div
    className="product-list"
    style={{
      position: "relative",       // 👈 important so loader can absolutely position inside
      minHeight: "150px"          // optional, ensures space even while loading
    }}
  >
    {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)", // semi-transparent overlay (optional)
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10
        }}
      >
        ⏳ Validating products...
      </div>
    )}

    {filteredProducts.map((p) => (
      <label
        key={p._id}
        style={{ display: "block", marginBottom: "0.25rem" }}
      >
        <input
          type="checkbox"
          checked={selectedProducts.includes(p.productName)}
          onChange={() => handleProductSelect(p.productName)}
        />
        {" "}{p.productName}
      </label>
    ))}
  </div>
        </div> */}



<div className="form-group full-width">
  <label>Select Products</label>

  <div
    className="product-list"
    style={{
      position: "relative",
      minHeight: "150px",
    }}
  >
    {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10,
        }}
      >
        ⏳ Validating products...
      </div>
    )}

    {/* 👇 Replace your old map() block with this one */}
    {filteredProducts.map((p) => {
      const isSelected = selectedProducts.includes(p.productName);
      const isBlocked = blockedProducts.has(p.productName);

      return (
        <label
          key={p._id}
          style={{
            display: "block",
            marginBottom: "0.25rem",
            opacity: isBlocked && !isSelected ? 0.5 : 1,
            cursor: isBlocked && !isSelected ? "not-allowed" : "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            disabled={isBlocked && !isSelected} // 🚫 block selection if product is in productGroup
            onChange={() => handleProductSelect(p.productName)}
          />
          {" "}{p.productName}
          {isBlocked && !isSelected && (
            <span style={{ color: "red", marginLeft: "5px" }}>(Blocked)</span>
          )}
        </label>
      );
    })}
  </div>
</div>

        {/* --- Verification --- */}
        <div className="verify-form-row">
          <div className="verify-form-group">
            <label>Verification Code</label>
            <input
              name="verifCode"
              value={formData.verifCode || ""}
              onChange={handleChange}
            />
          </div>
          <div className="verify-form-group">
            <label>Track ID *</label>
            <input
              name="trackId"
              value={formData.trackId || ""}
              onChange={handleChange}
            />
          </div>
            <div className="verify-form-group">
            <label>Center Name *</label>
            <input name="centerName" value={formData.centerName || ""} readOnly />
          </div>
        </div>

        <div className="verify-form-row">
        
          <div className="verify-form-group">
            <label>Agent Name *</label>
            <input name="agentName" value={formData.agentName || ""} readOnly />
          </div>
           <div className="verify-form-group">
            <label>Verifier Name *</label>
            <input name="verifName" value={formData.verifName || ""} readOnly />
          </div>
           <div className="verify-form-group">
            <label>Campaign *</label>
            <select
              name="campaign"
              value={formData.campaign}
              onChange={handleChange}
            >
              <option value="">-- Select Campaign --</option>
              {campaigns.map((c) => (
                <option key={c._id} value={c.campaignName}>
                  {c.campaignName}
                </option>
              ))}
            </select>
          </div>
        </div>
               <div className="verify-form-row">
        <div className="verify-form-group">
          <label>Disposition *</label>
          <select
            name="disposition"
            value={formData.disposition || ""}
            onChange={handleChange}
          >
            <option value="">Select Disposition</option>
            {dispositions.map((d) => (
              <option key={d._id} value={d.disposition}>
                {d.disposition}
              </option>
            ))}
          </select>
          </div>
           <div className="verify-form-group">
          <label>Comments</label>
          <textarea
            name="comments"
            maxLength={300}
            value={formData.comments || ""}
            onChange={handleChange}
            placeholder="Enter comments (max 300 chars)"
            rows={4}
          />
          <p className="char-count">
            {(formData.comments?.length || 0)}/300 characters
          </p>
        </div>
        </div>

       

        {/* Actions */}
        <div className="verify-form-actions">
          <button
            type="button"
            className="verify-btn-save"
            onClick={handleAgentUpdate}
          >
            Update
          </button>
          <button
            type="button"
            className="verify-btn-close"
            onClick={() => setShowAgentDialog(false)}
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
)}


    </div>
  );
}

export default AllForms;
